import React from "react";
import axios from "axios";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from "react-toasts";
import {API_URL} from "../../../utils/Common";

const initialFormData = Object.freeze({
    apellido: ''
})

const FormApellidos = (props) => {
    const [formData, updateFormData] = React.useState(initialFormData);

    const handleChange = (e) => {
        updateFormData({
            ...formData,
            // Trimming any whitespace
            [e.target.name]: e.target.value.trim()
        })
    }

    const onSubmit = (e) =>  {
        e.preventDefault();

        if (formData.apellido === "") {
            ToastsStore.error("Proporcione el apellido por favor!");
            return
        }
        axios.post(API_URL+'/catalogos/setApellido', formData)
            .then(r => {
                console.log(r.data)
                if (r.data.success) {
                    ToastsStore.success(r.data.message);
                    updateFormData({apellido: ""}); // TODO NO FUNCIONA revisar
                    props.fnGetApellidos(); // -- funcion del Padre
                } else {
                    ToastsStore.error(r.data.message)
                }
            })
            .catch(err => {
                console.log(err)
                ToastsStore.error("No se pudo conectar al servidor para el ingreso del apellido")
            })

    }

    return (
        <div>
            <form className="w-full max-w-lg" onSubmit={onSubmit}>
                <div className="flex flex-wrap -mx-3 mb-6">
                    <div className="w-full px-3 mb-6 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                               htmlFor="apellidos">
                            Nombre de la Variedad:
                        </label>
                        <input className="text-sm appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                               type="text" id="apellido" name="apellido"
                                onChange={handleChange}/>
                    </div>
                </div>
                <button type="submit" className="text-sm bg-orange-800 hover:bg-orange-700 text-white py-2 px-4 rounded shadow">
                    Guardar
                </button>
            </form>
            <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT}/>
        </div>
    );
}

export default FormApellidos;
